<template>
  <div>
    <Layout :pagetitle="$t('Company')">
      <form autocomplete="off" @submit.prevent="saveCompany">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Company') }}</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="6">
              <label>{{ $t('Name') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="name" />
            </b-col>
            <b-col md="6">
              <label>{{ $t('Require MFA') }}</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="require_mfa" v-model="require_mfa" />
                <label class="form-check-label" for="require_mfa">
                  {{ $t('Require MFA') }}
                </label>
              </div>
            </b-col>
          </b-row>

          <hr />
          <h6>{{ $t('Settings') }}</h6>
          <b-row>
            <b-col md="6">
              <label>{{ $t('Default Currency') }}</label>
              <b-form-input :trim="true" autocomplete="off" v-model="settings.moedaPadrao" placeholder="BRL" />
            </b-col>
            <b-col md="6">
              <label>{{ $t('Timezone') }}</label>
              <b-form-input
                :trim="true"
                autocomplete="off"
                v-model="settings.timezone"
                placeholder="America/Sao_Paulo"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <label>{{ $t('Default Language') }}</label>
              <b-form-select v-model="settings.linguagemPadrao" :options="languageOptions" />
            </b-col>
            <b-col md="6">
              <label>{{ $t('Image Size Limit (MB)') }}</label>
              <b-form-input
                :trim="true"
                autocomplete="off"
                type="number"
                v-model="settings.limite_tamanho_imagem"
                min="1"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <label>{{ $t('Default Document Type') }}</label>
              <b-form-select v-model="settings.tipoDocumentoDefault" :options="documentTypeOptions" />
            </b-col>
          </b-row>

          <hr />
          <h6>{{ $t('Advanced Settings') }}</h6>
          <b-row>
            <b-col md="6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="exibir_dashboard"
                  v-model="settings.exibir_dashboard"
                />
                <label class="form-check-label" for="exibir_dashboard">
                  {{ $t('Show Dashboard') }}
                </label>
              </div>
            </b-col>
            <b-col md="6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="exibir_imposto"
                  v-model="settings.exibir_imposto"
                />
                <label class="form-check-label" for="exibir_imposto">
                  {{ $t('Show Tax') }}
                </label>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="exibir_comissao"
                  v-model="settings.exibir_comissao"
                />
                <label class="form-check-label" for="exibir_comissao">
                  {{ $t('Show Commission') }}
                </label>
              </div>
            </b-col>
            <b-col md="6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="premios_origem"
                  v-model="settings.premios_origem"
                />
                <label class="form-check-label" for="premios_origem">
                  {{ $t('Prize Origin') }}
                </label>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="ocultar_cpa" v-model="settings.ocultar_cpa" />
                <label class="form-check-label" for="ocultar_cpa">
                  {{ $t('Ocultar CPA') }}
                </label>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <div>
            <button type="submit" class="btn btn-primary m-1" :disabled="$store.state.isLoading">
              {{ $t('Update') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import { getMenuItems } from '@/config/menuItems';
import authService from '@/services/auth.services';

export default {
  components: { Layout },
  data() {
    return {
      name: '',
      id_management: 0,
      require_mfa: false,
      settings: {
        moedaPadrao: null,
        timezone: null,
        linguagemPadrao: null,
        limite_tamanho_imagem: 1,
        tipoDocumentoDefault: 'cpf',
        exibir_dashboard: false,
        exibir_imposto: false,
        exibir_comissao: false,
        premios_origem: false,
        ocultar_cpa: false
      },
      languageOptions: [
        { value: null, text: this.$t('Select') },
        { value: 'pt-BR', text: 'Português (Brasil)' },
        { value: 'en', text: 'English' },
        { value: 'es', text: 'Español' }
      ],
      documentTypeOptions: [
        { value: 'cpf', text: 'CPF' },
        { value: 'cnpj', text: 'CNPJ' },
        { value: 'passport', text: this.$t('Passport') },
        { value: 'other', text: this.$t('Other') }
      ]
    };
  },
  mounted() {
    const usr = authService.getLoggedUser();
    if (usr?.root !== true) {
      this.$router.push({ name: '404' });
      return;
    }
    if (this.$route.params?.id) {
      this.getCompany();
    }
  },
  methods: {
    saveCompany() {
      if (!this.validateCompany()) return;

      if (!this.$route.params?.id) {
        this.$customAlert({
          type: 'error',
          msg: this.$t('Error loading company')
        });
        return;
      }

      this.updateCompany();
    },
    getCompany() {
      const companyId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/company/${companyId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let company = res.data;

          this.name = company.name || '';
          this.id_management = company.id_management || 0;
          this.require_mfa = Boolean(company.require_mfa);

          const companySettings = company?.settings || {};
          this.settings = {
            moedaPadrao: companySettings.moedaPadrao || null,
            timezone: companySettings.timezone || null,
            linguagemPadrao: companySettings.linguagemPadrao || null,
            limite_tamanho_imagem: companySettings.limite_tamanho_imagem || 1,
            tipoDocumentoDefault: companySettings.tipoDocumentoDefault || 'cpf',
            exibir_dashboard: Boolean(companySettings.exibir_dashboard),
            exibir_imposto: Boolean(companySettings.exibir_imposto),
            exibir_comissao: Boolean(companySettings.exibir_comissao),
            premios_origem: Boolean(companySettings.premios_origem),
            ocultar_cpa: Boolean(companySettings.ocultar_cpa)
          };

          if (company.settings) {
            localStorage.setItem(`company_${companyId}_settings`, JSON.stringify(this.settings));
          }
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.error('Error loading company:', err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Error loading company')
          });
        });
    },
    updateCompany() {
      let companyId = this.$route.params.id;

      // Garantir que todos os valores booleanos sejam enviados corretamente
      let company = {
        name: this.name,
        require_mfa: Boolean(this.require_mfa),
        settings: {
          moedaPadrao: this.settings.moedaPadrao || null,
          timezone: this.settings.timezone || null,
          linguagemPadrao: this.settings.linguagemPadrao || null,
          limite_tamanho_imagem: this.settings.limite_tamanho_imagem || 1,
          tipoDocumentoDefault: this.settings.tipoDocumentoDefault || 'cpf',
          exibir_dashboard: Boolean(this.settings.exibir_dashboard),
          exibir_imposto: Boolean(this.settings.exibir_imposto),
          exibir_comissao: Boolean(this.settings.exibir_comissao),
          premios_origem: Boolean(this.settings.premios_origem),
          ocultar_cpa: Boolean(this.settings.ocultar_cpa)
        }
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/company/${companyId}`, company)
        .then(() => {
          this.$store.commit('SET_LOADING', false);

          localStorage.setItem(`company_${companyId}_settings`, JSON.stringify(company.settings));

          const user = authService.getLoggedUser();
          if (user && user.company && user.company.id === companyId) {
            user.company.settings = company.settings;
            localStorage.setItem('user', JSON.stringify(user));

            if (this.$store.state?.session?.user) {
              const session = { ...this.$store.state.session };
              if (typeof session.user === 'string') {
                session.user = JSON.parse(session.user);
              }
              session.user.company.settings = company.settings;
              this.$store.commit('SET_SESSION', session);
            }
          }

          this.$store.commit('SET_COMPANY_SETTINGS', company.settings);
          this.$store.commit('SET_MENU_ITEMS', getMenuItems());

          this.$customAlert({
            type: 'success',
            msg: this.$t('Company updated successfully')
          });
          this.$router.push({
            name: 'companyList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.error('Error updating company:', err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Error updating company')
          });
        });
    },
    validateCompany() {
      if (!this.name || this.name.trim().length === 0) {
        this.$customAlert({
          msg: this.$t('Name is required'),
          type: 'error'
        });
        return false;
      }

      return true;
    }
  }
};
</script>

<style></style>
